import { z } from 'zod';

// ケアマネ様式で共通の部品。
// 旧実装の来歴列（createdOrigin / ai / reviewFlags）と状態・確定者は DB の列へ移すので本文に入れない。
// 旧「noChange（変化なし確認）」は下書きの状態なので本文に入れない（新基盤では前版を写した下書きで表す）。

export const CONFIRMERS = ['caremanager'];

export const idString = z.string().min(1);

// 旧 API は日付の形を検査していない（自由文字列）。画面のために date の印だけ付ける
export const dateText = (label: string) => z.string().meta({ kind: 'date' }).describe(label);

// 旧 API の YYYY-MM-DD 検査（会議の開催日など、キーになっていた日付）
export const ymd = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD で入力してください');

export const longtext = (label: string, max?: number) =>
  (max === undefined ? z.string() : z.string().max(max)).meta({ longtext: true }).describe(label);

// AI 下書きの根拠。旧 API では任意（Python のエージェントは事象・モニタリング以外で必須にしていた）。ここは API 側に合わせ任意
export const reasonField = z.string().optional().describe('根拠の説明（AI下書き）');
export const evidenceEventIdsField = z.array(idString).optional().describe('根拠の記録ID');

export const evidenceFields = {
  reason: reasonField,
  evidenceEventIds: evidenceEventIdsField,
};
